import { useState, useCallback } from 'react';

export function useResizableCols(storageKey, defaults) {
  const [widths, setWidths] = useState(() => {
    try {
      const saved = localStorage.getItem(storageKey);
      if (saved) return { ...defaults, ...JSON.parse(saved) };
    } catch {}
    return { ...defaults };
  });

  const startResize = useCallback((colKey, e) => {
    e.preventDefault();
    const startX = e.clientX;
    const startW = widths[colKey] ?? defaults[colKey] ?? 100;
    let lastW = startW;

    const onMove = (ev) => {
      lastW = Math.max(40, startW + ev.clientX - startX);
      setWidths(prev => ({ ...prev, [colKey]: lastW }));
    };

    const onUp = () => {
      setWidths(prev => {
        const next = { ...prev, [colKey]: lastW };
        try { localStorage.setItem(storageKey, JSON.stringify(next)); } catch {}
        return next;
      });
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };

    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
  }, [widths, defaults, storageKey]); // eslint-disable-line

  return { widths, startResize };
}
